import AppBar from './AppBar';
import Content from './Content';
import Drawer from './Drawer';
import MiniVariantDrawer from './MiniVariantDrawer';

export default Object.assign(MiniVariantDrawer, {AppBar, Content, Drawer});
